export function AppLoader() {
  return <div className="app-splash" role="status" aria-label="Загрузка BnB Nodes">
    <div className="app-splash__coin" aria-hidden="true">
      <span className="app-splash__face" />
      <span className="app-splash__face app-splash__face--back" />
    </div>
  </div>;
}
